import { Payer } from '../../types/commerce';

const PAYER_FIELDS: ReadonlyArray<readonly [key: keyof Payer, label: string, type: string]> = [
  ['name', 'Payer name', 'text'],
  ['email', 'Payer email', 'email'],
  ['phone', 'Payer mobile number (India)', 'tel'],
];

interface Props {
  readonly payer: Payer;
  readonly onChange: (key: keyof Payer, value: string) => void;
  readonly locked: boolean;
}

export default function PayerForm({ payer, onChange, locked }: Props) {
  return (
    <section>
      <h2>Payer contact</h2>
      <p>These details are passed to the payment provider. They may differ from the delivery recipient.</p>
      <fieldset disabled={locked}>
        {PAYER_FIELDS.map(([key, label, type]) => (
          <label key={key}>
            {label}
            <input required type={type} value={payer[key]} onChange={(e) => onChange(key, e.target.value)} />
          </label>
        ))}
      </fieldset>
    </section>
  );
}
